import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-wrap items-center justify-center gap-3 py-8">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-100 border border-background-200/70 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 hover:border-primary-200 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className={`${cat.icon} text-base`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}